import React, { FunctionComponent,useState } from 'react'
import { Modal,Button,FormControl,Col,FormLabel, Form, Row, FormCheck, Accordion, Offcanvas, Tabs, Tab } from 'react-bootstrap'
import PropTypes,{InferProps} from 'prop-types'
import parse from 'html-react-parser'
import { SankeyData, SankeyDataPropTypes, TagsGroup } from './types'
import { convert_data } from 'open-sankey/dist/SankeyConvert'
import FileSaver from 'file-saver'
import SankeyUncert from './SankeyUncert'
import { setSelectedTags } from 'open-sankey/dist/SankeyUtils'
import DropdownMultiselect from 'react-multiselect-dropdown-bootstrap'

declare const window: Window &
typeof globalThis & {
  SankeyToolsStatic: boolean
  sankey: {
    sankey_data_file:RequestInfo
    sous_filieres : { [ key : string ] : string }
    units: string[],
    flask_logo? : string,
    flask_header? : string,
    logo_width? : number,
    legend_average : string,
    legend_uncert : string,
    welcome_text? : string,
    help_text : string
    excel : string
  }
}
const SankeyBannerMenuPropTypes = {
  sankey_data: PropTypes.shape(SankeyDataPropTypes).isRequired,
  set_sankey_data: PropTypes.func.isRequired,
  set_default_tooltip: PropTypes.func.isRequired
}

type SankeyBannerMenuTypes = InferProps<typeof SankeyBannerMenuPropTypes>

const SankeyBannerMenu : FunctionComponent<SankeyBannerMenuTypes> = (
  {sankey_data,set_sankey_data,set_default_tooltip}
) => {
  const [show_readme,set_show_readme] = useState(false)
  const [agregation_level,set_agregation_level] = useState(1)
  const [user_scale, set_user_scale] = useState(sankey_data.user_scale)
  const [sous_filiere] = useState<string[]>([])
  const [nav_item_active, set_nav_item_active] = useState<string>('')

  const clickSavePDF = () => {
    localStorage.setItem('data',JSON.stringify(sankey_data))
    const svg = window.d3.select('svg')
    svg.selectAll('.tooltip').remove()
    svg.selectAll('text[visibility=hidden]').remove() 
    const html_node = svg.attr('title', 'test2')
      .attr('version', 1.1)
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .node() as HTMLElement
    if (html_node === null || html_node.parentNode === null ) {
      return
    }
    const html = (html_node.parentNode as HTMLElement).innerHTML

    const blob = new Blob([html], {type: 'image/svg+xml'})
    const form_data = new FormData()
    form_data.append('svg', blob)

    const arr = window.location.href.split('/') 
    delete arr[arr.length - 1]
    delete arr[arr.length - 2]
    let url = 'https://terriflux.fr/sankey-diagrams/sankey/save_pdf'
    console.log(url)
    const fetchData = {
      method: 'POST',
      body: form_data
    }
        
    const showFile = (blob: BlobPart) => {
      const newBlob = new Blob([blob], {type: 'application/pdf'})
      FileSaver.saveAs(newBlob, 'sankey_diagram.pdf')
    }
    const cleanFile = () => {
      const fetchData = {
        method: 'POST'
      } 
      url = 'https://terriflux.fr/sankey-diagrams/sankey/clean_pdf'
      fetch(url, fetchData)      
    }

    fetch(url, fetchData).then(
      r => r.blob()
    ).then(showFile).then(cleanFile)

    const json_data = localStorage.getItem('data') || ''
    const new_data = JSON.parse(json_data)
    set_sankey_data(new_data)
  }

  const setDiagram = (evt : React.ChangeEvent) => {
    
    const diagram = (evt.target as HTMLInputElement).value as string
    const sous_filieres = window.sankey.sous_filieres
    //const path = (window.sankey.sankey_data_file as string).split('/')
    const new_data = (window.sankey as any)[sous_filieres[diagram] as any]
    Object.assign(sankey_data, new_data)
    sankey_data.static_sankey = true
    // const new_file_name = path.join('/')
    // fetch(new_file_name).then( (response) => {
    //   response.text().then( (text)=> {
    //     const result = text.split('<br>').join('\\\\n')
    //     const new_data : SankeyData = JSON.parse(result)
    //     Object.assign(sankey_data, new_data)
    //     sankey_data.node_width = new_data.node_width
    //     sankey_data.file_path = new_file_name
    //     sankey_data.static_sankey = true
    //     convert_data(sankey_data)
    //     if (sankey_data.default_tooltip === false) {
    //       set_default_tooltip(false)
    //     }
    set_level(agregation_level)
    set_sankey_data({...sankey_data})
    //   })
    // })
  }

  const set_level = (agregation_level:number) => {
    for (let level = 1; level<=agregation_level; level++) {
      Object.values(sankey_data.nodes).forEach( n => {
        if (!n.dimensions['Primaire'] || !n.dimensions['Primaire'].level) {
          n.display = false
          n.node_visible = false
          return
        }
        if (n.dimensions['Primaire'].level === level ) {
          n.node_visible = true
          n.display = true
          Object.keys(n.dimensions).forEach( dim => {
            const idParent = n.dimensions[dim].parent_name
            if (idParent !== null && idParent !== undefined) {
              sankey_data.nodes[idParent].node_visible = false
              sankey_data.nodes[idParent].display = false
            }
          })
        } else if (n.dimensions['Primaire'].level > level )  {
          n.node_visible = false
          n.display = false
        }
      })
    }
  }
    
  const handleSimpleDropdown = (evt: React.ChangeEvent<HTMLSelectElement>, tags_group:TagsGroup) => {
    const val = evt.target.value
    Object.entries(tags_group.tags).forEach(tag=> tag[1].selected = val === tag[1].name )
    setSelectedTags(sankey_data)
    set_sankey_data({ ...sankey_data })
  }

  const handleMultiDropdown = (selected: string[],tags_group:TagsGroup) => {
    console.log(selected)
    Object.entries(tags_group.tags).forEach(tag=> tag[1].selected = selected.includes(tag[1].name) )
    setSelectedTags(sankey_data)
    set_sankey_data({ ...sankey_data })
  }
  
  set_level(agregation_level)

  const { tags_catalog,display_style,units_names} = sankey_data
  const show_uncert_dialog = Object.values(sankey_data.links).filter(l => ('mini' in l || 'maxi' in l) && l.mini !== l.maxi ).length > 0 
  let sous_filieres = undefined
  if (window.sankey  && window.sankey.sous_filieres  ) {
    console.log(window.sankey.sous_filieres)
    sous_filieres = window.sankey.sous_filieres
  }

  let units = undefined
  if (units_names  && units_names.length > 0 && units_names[0]) {
    units = [units_names[0][0], 'Naturelles']
  }
  const diagram_label = sankey_data.diagrams_selector_label ? sankey_data.diagrams_selector_label : 'Diagrammes'
  //const unit = display_style.unit ? 'equivalent' : 'natural'

  const region_group = tags_catalog['Regions']
  const periods_group = tags_catalog['Periods']

  let max_user_scale = 0
  Object.values(sankey_data.links).forEach(link => link.value.forEach(v => max_user_scale = v > max_user_scale ? v : max_user_scale))
  max_user_scale = max_user_scale*2

  return (
    <>
      <Form
        className='herowrap' 
        style={{
          color: 'white',
          backgroundColor : '#3c3c3c',
          paddingBottom : '3px', 
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: '<baseline-position>'
        }}>
        { (sankey_data.static_sankey && sous_filieres)  ? (
          <Form.Group as={Col} style={{marginLeft : '30px'}}>
            <Row>
              <FormLabel className="text-center" >{diagram_label}</FormLabel>
            </Row>
            <Row>
              <FormControl as="select" onChange={setDiagram}>
                {Object.keys(sous_filieres).map( (name,i) => <option key={i} value={name} selected={sous_filiere.includes(name) } >{name}</option>)}
              </FormControl>
            </Row>
          </Form.Group>): (<div/>)}
        <Form.Group as={Col} style={{marginLeft : '30px', width: '100px'}}>
          <Row>
            <FormLabel>Niveau de détail</FormLabel>
          </Row>
          <Row>
            <Form.Select id="selectionNode"
              onChange={
                (evt: React.ChangeEvent<HTMLSelectElement>) => {
                  if (evt.target.value ==='') {
                    return
                  }
                  set_level(+evt.target.value)
                  set_agregation_level(+evt.target.value)
                  set_sankey_data({...sankey_data})
                }
              }
            >
              {[1,2,3].map( level => <option key={level} value={level} selected={level === agregation_level} >{'Niveau '+level}</option>)}
            </Form.Select>
          </Row>
        </Form.Group>
        { region_group ? (
          <Form.Group as={Col} style={{marginLeft : '30px'}}>
            <Row>
              <FormLabel className="text-center" >Régions</FormLabel>
            </Row>
            <Row>
              {<Form.Select key={region_group.group_name} placeholder='all' onChange={(evt: React.ChangeEvent<HTMLSelectElement>) => { handleSimpleDropdown(evt, region_group) }}>{
                Object.entries(region_group.tags).map(([tag_key, tag]) => {
                  return (<option key={tag_key} value={tag_key}>{tag.name}</option>)
                })}
              </Form.Select>}
            </Row>
          </Form.Group>
        ) : (<div/>)}
        { periods_group ? (
          <Form.Group as={Col} style={{marginLeft : '30px'}}>
            <Row>
              <FormLabel className="text-center" >Années</FormLabel>
            </Row>
            <Row>
              {<Form.Select key={periods_group.group_name} placeholder='all' onChange={(evt: React.ChangeEvent<HTMLSelectElement>) => { handleSimpleDropdown(evt, periods_group) }}>{
                Object.entries(periods_group.tags).map(([tag_key, tag]) => {
                  return (<option key={tag_key} value={tag_key}>{tag.name}</option>)
                })}
              </Form.Select>}
            </Row>
          </Form.Group>
        ) : (<div/>)}

        { Object.entries(tags_catalog).filter(tags_group => tags_group[1].banner === 'multi' && tags_group[0] !== 'Exchanges' &&  tags_group[0] !== 'flux_types' &&  tags_group[0] !== 'Uncert' ).map((tags_group,i) => {
          return (
            <Form.Group as={Col} key={i} style={{marginLeft : '30px', width: '100px'}}>
              <Row>
                <FormLabel className="text-center">{tags_group[1].group_name}</FormLabel>
              </Row>
              <Row>
                <DropdownMultiselect 
                  key={i} 
                  selected={Object.entries(tags_group[1].tags).map(tag => tag[1].selected ? tag[1].name : null).filter(tag_name => tag_name !== null)} 
                  name={tags_group[1].group_name} 
                  options={Object.entries(tags_group[1].tags).map(tag => tag[1].name)} 
                  handleOnChange={(selected : string[]) => { handleMultiDropdown(selected, tags_group[1]) }} />
              </Row>
            </Form.Group>
          )}
        )}
        { Array.isArray(units) ? (
          <Form.Group as={Col} style={{marginLeft : '30px', width: '100px'}}>
            <Row>
              <FormLabel className="text-center" >Unités</FormLabel>
            </Row>
            <Row>
              <Form.Select 
                onChange={ evt=> {
                  const unit = evt.target.value
                  sankey_data.display_style.unit = unit === 'Naturelles'
                  set_sankey_data({...sankey_data})
                }}>
                {units.map( 
                  (name,i) => 
                    <option key={i} value={name} selected={ ((name === 'Naturelles') && display_style.unit ) ||  ((name !== 'Naturelles') && !display_style.unit ) }>{name}</option>)}
              </Form.Select>
            </Row>
          </Form.Group>
        ) : (<div/>)}
        { show_uncert_dialog ? (<SankeyUncert sankey_data={sankey_data} set_sankey_data={set_sankey_data}></SankeyUncert>) : (<></> )}
        { sankey_data.static_sankey ? (
          <Form.Group as={Col} style={{marginLeft : '30px'}}>
            <Row>
              <FormLabel className="text-center" >Export</FormLabel>
            </Row>
            <Row>
              { window.sankey && window.sankey.excel ? (
                <Col >
                  <Button  href={window.sankey.excel}>
                    Excel
                  </Button>
                </Col>
              ) : (<></>)}
              <Col >
                <Button  onClick={clickSavePDF}>
                  PDF               
                </Button>
              </Col>
            </Row>
          </Form.Group>
        ) : (<></> )}
        { sankey_data.static_sankey ? (
          <Col > 
            <br/>
            <Button 
              style={{marginLeft : '30px'}}
              size="sm" 
              onClick={()=>set_show_readme(true)}
            >
                Aide
            </Button>               
          </Col>
        ) : (<div/>)}
        <Col>
          <Accordion activeKey={nav_item_active} style={{ backgroundColor : '#3c3c3c' }} >
            <Accordion.Item
              eventKey="0"
              onClick={ evt=>{
                if ((evt.target as any).className === 'accordion-button' && nav_item_active === '0') {
                  set_nav_item_active('')
                } else {
                  set_nav_item_active('0')
                }
              }}
            >
              <Accordion.Header  style={{ backgroundColor : '#3c3c3c'}}>Avancé</Accordion.Header>
              <Accordion.Body  style={{ backgroundColor : '#3c3c3c'}}>
                <Form.Group as={Row} >
                  <Col>
                    <FormLabel >Echelle</FormLabel>
                  </Col>
                  <Col>
                    <FormControl
                      type="text"
                      value={user_scale}
                      onChange={evt => set_user_scale(+evt.target.value)}
                      onBlur={() => {
                        sankey_data.user_scale = user_scale
                        set_sankey_data({ ...sankey_data })
                      }}
                    />
                    <FormControl.Feedback />
                    <Form.Text>(valeur pour 100px)</Form.Text>
                  </Col>
                </Form.Group>
                { Object.entries(tags_catalog).filter(tags_group => tags_group[1].banner === 'multi' && (tags_group[0] === 'Exchanges' ||  tags_group[0] === 'flux_types' ||  tags_group[0] === 'Uncert') ).map((tags_group,i) => {
                  return (
                    <Form.Group as={Col} key={i} style={{marginLeft : '30px', width: '200px', backgroundColor : '#3c3c3c'}}>
                      <Row>
                        <FormLabel className="text-center">{tags_group[1].group_name}</FormLabel>
                      </Row>
                      <Row>
                        <DropdownMultiselect 
                          key={i} 
                          selected={Object.entries(tags_group[1].tags).map(tag => tag[1].selected ? tag[1].name : null).filter(tag_name => tag_name !== null)} 
                          name={tags_group[1].group_name} 
                          options={Object.entries(tags_group[1].tags).map(tag => tag[1].name)} 
                          handleOnChange={(selected : string[]) => { handleMultiDropdown(selected, tags_group[1]) }} />
                      </Row>
                    </Form.Group>
                  )}
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Form>
      <Modal 
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          'color':'black'
        }}
        size="lg"
        show={show_readme} 
        onHide={()=>set_show_readme(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Aide</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Tabs defaultActiveKey="diagram" id="diagram">
                <Tab eventKey="diagram" title="Diagramme">
                  <br></br>
                  <p>L&apos;épaisseur des flèches est proportionnelle aux flux.</p>
                  <p>L&apos;affichage de la valeur des flux peut se faire en <b><i>{sankey_data.units_names[0]}</i></b> ou en unités naturelles (sélecteur <b>Unités</b>).</p>
                  <p>Le diagramme peut être visualisé avec différents niveaux d&apos;agrégations en utilisant le sélecteur <b>Niveau de détail</b></p>
                  <p>Des filtres peuvent être utilisés pour n&apos;afficher que des parties du diagramme. Pour cela utiliser les selecteurs <b> 
                    {Object.entries(tags_catalog).filter(tags_group => tags_group[1].banner === 'multi' && tags_group[0] !== 'Exchanges' &&  tags_group[0] !== 'flux_types' &&  tags_group[0] !== 'Uncert' ).map((tags_group,i) => { return ' '+tags_group[1].group_name })}
                  </b></p><p><b>Les valeurs de flux</b> sont affichées en moyenne ou avec leurs intervalles d&apos;incertitudes (sélecteur Valeurs visualisées)</p>
                  <p>Pour obtenir des informations sur chaque flux, appuyer sur <b>shift</b> et passer la souris sur le flux. Les valeurs apparaissent en différentes unités (dépendant du produit considéré)
                  avec leur intervalle de confiance. Les hypothèses utilisées sont  affichées. Pour les flux pour lesquels des données ont été collectés les informations sur la source et l&apos;année sont aussi fournies.</p>
                  <p>Le fichier excel contenant les données est téléchargeable en cliquant sur le bouton <b>Excel</b>.</p>
                  <p>Les diagrammes de flux peuvent être extraits dans un format PDF en cliquant sur le bouton <b>PDF</b>.</p>
                </Tab>
                <Tab eventKey="filiere" title="Filière">
                  <p>A remplir</p>
                </Tab>
                <Tab eventKey="units" title="Unités">
                  <p>Nous fournissons les valeurs des flux en plusieurs unités (ex : m3, tonnes, tonnes sèches, MWh…).
                    Cependant, il faut choisir une unité principale pour mener l’étude.
                    Le choix de cette unité repose sur trois critères :</p> 
                  <ul>
                    <li>Pouvoir appliquer les lois de conservation de la masse</li>
                    <li>Ne pas faire apparaître les flux d’eau dans l’étude</li>
                    <li> Avoir une unité qui parle aux acteurs</li>
                  </ul>
                  <p>Il aurait été possible de travailler en masse sèche (MS). Cependant, à l’amont de la filière il est 
                    beaucoup plus naturel d’exprimer les flux en volume.</p>  
                  <p>Comme d’autres* (choisissons de travailler en m3 équivalent bois fibre qui représente le volume 
                      équivalent de bois rond au point de saturation des fibres (environ 30% d’humidité sur sec, 23% humidité sur brut).</p> 
                  <p>Les autres unités sont définis comme ça:</p>
                  { sankey_data.units_names.slice(2).map(
                    (units_desc,i) => { return (<p key={i} > <b>{units_desc[0]}</b> : {units_desc[1]} </p>) }
                  )}                 
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}

SankeyBannerMenu.propTypes = SankeyBannerMenuPropTypes

export default SankeyBannerMenu